import { useQuery } from '@tanstack/react-query'
import type { UserProfile } from '@app/types'
import { AdminService } from '@app/services/adminService'
import { USERS_QUERY_KEY } from '../utils/Admin.constants'

export const useFetchAdminUsers = () => {
  return useQuery<UserProfile[]>({
    queryKey: [USERS_QUERY_KEY],
    queryFn: AdminService.getClientUsers,
  })
}
